import { render, staticRenderFns } from "./MenuRagioneria.vue?vue&type=template&id=a73d89ba&"
import script from "./MenuRagioneria.vue?vue&type=script&lang=ts&"
export * from "./MenuRagioneria.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports